import {
  CREATE_USER,
  FETCH_USER_LIST,
  FETCH_USER_AGENTS_LIST,
  UPDATE_USER,
  FETCH_ALL_USER_LIST,
  FETCH_USER_AGENTS_MANAGERS_LIST,
  FETCH_LOCATION_BASE_AGENTS_LIST,
} from "./types";

export const fetchUsers = (payload?: any) => {
  return {
    type: FETCH_USER_LIST,
    payload,
  };
};

export const fetchAllUsers = (payload?: any) => {
  return {
    type: FETCH_ALL_USER_LIST,
    payload,
  };
};

export const fetchUserAgents = (payload?: any) => {
  return {
    type: FETCH_USER_AGENTS_LIST,
    payload,
  };
};

export const fetchLocationBaseAgents = (payload?: any) => {
  return {
    type: FETCH_LOCATION_BASE_AGENTS_LIST,
    payload,
  };
};

export const fetchUserAgentManagers = () => {
  return {
    type: FETCH_USER_AGENTS_MANAGERS_LIST,
  };
};

export const createUser = (payload: any) => {
  return {
    type: CREATE_USER,
    payload,
  };
};

export const updateUser = (payload: any) => {
  return {
    type: UPDATE_USER,
    payload,
  };
};
